export const DOWNLOADS_PLACEHOLDER_ID = 'downloads-portal-placeholder';
